import React from "react";
import StatusCimPage from "./StatusCimPage";

export default function StatusCimContainer({ onBack }) {
  return <StatusCimPage onBack={onBack} />;
}
